import React, { useEffect, useState } from "react";
import AccessibleModal from "../AccessibleModal";
import PublicBookingWompiInlineCard from "./PublicBookingWompiInlineCard";
import { bookingPaymentCallable } from "../../utils/bookingPaymentCallable";
export default function BookingPaymentRecovery({ booking, onClose }) {
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [starting, setStarting] = useState(false);
  useEffect(() => {
    let current = true;
    setResult(null);
    setError("");
    bookingPaymentCallable("getBookingPaymentRecovery")({ businessId: booking.businessId, bookingId: booking.id })
      .then(({ data }) => { if (current) setResult(data); })
      .catch((err) => { if (current) setError(err.message || "No pudimos consultar el pago. No inicies otro cobro."); });
    return () => { current = false; };
  }, [booking.businessId, booking.id]);
  const startPayment = async () => {
    if (starting || result?.recoveryState !== 'ready') return;
    setStarting(true);
    setError('');
    try {
      const {data: session} = await bookingPaymentCallable('createWompiPaymentSession')({businessId:booking.businessId,bookingId:booking.id,mode:result.mode});
      setResult({recoveryState:'checkout',session,balanceCents:Math.max(0,Math.round(Number(session.projectedBalanceAmount || 0)*100))});
    } catch (err) {
      setError(err.message || 'No pudimos preparar el abono. Cierra y vuelve a consultar el pago antes de intentarlo de nuevo.');
      setResult(null);
    } finally { setStarting(false); }
  };
  return <AccessibleModal open layer="stacked" onClose={onClose} labelledBy="booking-payment-recovery-title" width={600}>
    <div style={{ maxHeight: "80dvh", overflowY: "auto", padding: 16 }}>
      <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}><h2 id="booking-payment-recovery-title">Pago de tu reserva</h2><button type="button" onClick={onClose}>Cerrar</button></header>
      {error ? <p role="alert">{error}</p> : !result ? <p role="status">Consultando el pago…</p> : result.recoveryState === 'ready' ? <div>
        <p>{result.message}</p>
        <p>{result.mode==='balance'?'Saldo pendiente':'Abono'}: <strong>{new Intl.NumberFormat('es-PA',{style:'currency',currency:'USD'}).format(result.amountInCents/100)}</strong></p>
        <p>No se cobrará automáticamente. Tú autorizas el pago en el siguiente paso.</p>
        <button type="button" disabled={starting} onClick={startPayment}>{starting ? 'Preparando…' : result.mode==='balance'?'Continuar al pago del saldo':'Continuar al abono'}</button>
      </div> : !['transaction','checkout'].includes(result.recoveryState) ? <p role="status">{result.message}</p> :
        <PublicBookingWompiInlineCard businessId={booking.businessId} bookingId={booking.id} session={result.session} balanceCents={result.balanceCents} recoveryState={result.providerState} />}
    </div>
  </AccessibleModal>;
}
